'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _moment = require('moment/moment');var _moment2 = _interopRequireDefault(_moment);
var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');
var _reactScroll = require('react-scroll');

var _PublishNewHomesFormComponent = require('./PublishNewHomesFormComponent');var _PublishNewHomesFormComponent2 = _interopRequireDefault(_PublishNewHomesFormComponent);

var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _creationNewHomes = require('../../redux/modules/creationNewHomes');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}





var selector = (0, _reduxForm.formValueSelector)('addNewProject');

var scrollToFirstError = function scrollToFirstError(errors) {
  if (!errors) {return;}
  var errorFields = Object.keys(errors);

  _reactScroll.scroller.scrollTo(errorFields[0], {
    duration: 500,
    smooth: true,
    offset: -95 });

};

var mapStateToProps = function mapStateToProps(state) {
  var route = state.routing.locationBeforeTransitions.pathname;
  var editProjectIdx = route.indexOf('/project/edit');
  var editForeignProjectIdx = route.indexOf('/foreign_project/edit');
  var isEditProject =
  editProjectIdx === 0 ||
  editProjectIdx === 3 ||
  editForeignProjectIdx === 0 ||
  editForeignProjectIdx === 3;

  var editedProject = state.manageProperties ? state.manageProperties.editedProject : null;
  var team = editedProject && isEditProject ? editedProject.team : null;
  var formattedDate = editedProject ? (0, _moment2.default)(editedProject.completion_date || '') : '';
  var formattedMonth = editedProject && Number(formattedDate.format('MM'));
  var formattedYear = editedProject && Number(formattedDate.format('YYYY'));

  return {
    fields: {
      description: selector(state, 'description'),
      commodities: selector(state, 'commodities'),
      advantages: selector(state, 'advantages'),
      summary: selector(state, 'summary'),
      nameProject: selector(state, 'name_project'),
      rooms: selector(state, 'rooms'),
      project_img: selector(state, 'project_img'),
      projectImages: selector(state, 'projectImages'),
      address: selector(state, 'address'),
      ownerImg: selector(state, 'ownerImg'),
      contractorImg: selector(state, 'contractorImg'),
      architectImg: selector(state, 'architectImg'),
      buildings: selector(state, 'buildings'),
      apartments: selector(state, 'apartments'),
      floors: selector(state, 'floors'),
      phone_number: selector(state, 'phone_number') },

    initialValues: editedProject && isEditProject && {
      name_project: editedProject.name,
      status: editedProject.status,
      room_range: editedProject.room_range,
      property_types: editedProject.property_types,
      currency: editedProject.currency,
      address: editedProject.address,
      summary: editedProject.summary,
      description: editedProject.description,
      project_img: editedProject.logo,
      projectImages: editedProject.images.map(function (item) {return {
          description: '',
          full: item,
          gallery: item,
          thumbnail: item };}),

      commodities: editedProject.commodities,
      advantages: editedProject.advantages,
      buildings: editedProject.buildings,
      apartments: editedProject.apartments,
      floors: editedProject.floors,
      minimal_price: editedProject.min_property_price,
      exact_price: editedProject.exact_property_price,
      completion_date: editedProject.completion_date,
      team: team,

      owner: team && team.owner ? team.owner.title : null,
      contractor: team && team.contractor ? team.contractor.title : null,
      architect: team && team.architect ? team.architect.title : null,
      completion_date_months: formattedMonth,
      completion_date_years: formattedYear,
      phone_number: editedProject.phone_number },

    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userData: state.userAuthentication.data,
    creationNewHomes: state.creationNewHomes,
    contactUs: state.contactUs,
    isMessageModalOpen: state.messageModal.isMessageModalOpen };

};exports.default =

(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, {
  addNewProject: _creationNewHomes.addNewProject,
  loadPropertyTypes: _creationNewHomes.loadPropertyTypes,
  editMyProject: _creationNewHomes.editMyProject }),

(0, _reduxForm.reduxForm)({
  form: 'addNewProject',
  validate: _validate2.default,
  enableReinitialize: global.location && (global.location.pathname.indexOf('property/edit') !== -1 ||
  global.location.pathname.indexOf('foreign_property/edit') !== -1),
  onSubmitFail: function onSubmitFail(errors) {return scrollToFirstError(errors);} }))(_PublishNewHomesFormComponent2.default);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/PublishNewHomesForm.js
// module id = 3044
// module chunks = 0